/**
 * 预约提货组件
 * 编辑 及 查看时 显示 StepSecond 内容
 * 注意：编辑时-----提货方式类型不可编辑，时间不可编辑，其他可
 *
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2023, all rights reserved. Essa.cn
 *
 * @param buyerId 必传
 * @param deliveryOrderId 编辑时传入此id,等同于将以有否 deliveryOrderId 判断是否编辑状态
 * @param selectPoIds 传入时，如果查询有些poid 即会默认勾选上
 **/
import React from "react";
import {Button, Drawer, Spin, message, Space} from 'antd';
import Lang from "@/components/Lang/Lang";
import PropTypes from 'prop-types';
import {isEmpty,} from '@utils/utils';
import StepOne from "./stepOne/stepOne";
import AuthBtn from "@components/HoverIcon/AuthBtn";
import StepSecond from "./stepSecond/stepSecond"
import PickUpPoDrawerAction from "./pickUpPoDrawer.action";
import './index.less'
export default class BatchPickUpPoDrawer extends React.Component{
    static propTypes = {
        buyerId: PropTypes.number.isRequired,
    }
    static defaultProps = {
        buyerId:"",
        deliveryOrderId:"",
        selectPoIds:[],
    };
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            loading:false,
            showStep: 1,
        }
    }
    /**
     * 抽屜
     * */
    showDrawer = (flag=true) => {
        if(flag){
            // if(isEmpty(this.props.deliveryOrderId)){
                this.initOne()
            // }else { // 有提货ID的为编辑 状态 直接进入下一步
            //     this.goStepTwo()
            // }
        }else {
            //关闭即还原为步骤1 及其数据
            this.showStep(1);
            this.setOneData();
            this.onChangeOne();
            this.setState({
                selectIds: []
            })
            this.setState({
                visible: flag,
            });
        }
    };
    showStep(num=1){
        if(num==2){//点击下一步时
            if(this.onRefChildOne){
              const poIds = this.onRefChildOne.handleOk();
              if(poIds&&poIds.length>0){
                  this.goStepTwo(poIds)
              }else {
                  // 请选择订单
                  message.info(__getServerLanguage("QingXuanZeDingDan"))
              }
            }
        }else {
            this.setState({
                showStep: num,
            });
        }
    }
    goStepTwo(poIds,callBack){
        let data = {}, sUrl = ""
        // if(isEmpty(this.props.deliveryOrderId)){
            sUrl= "/mg/abd/whs/deliveryOrder/delivery-order-initi";
            data = {
                poIds: poIds,
            }
        // }else { // 有提货ID的为编辑 状态
        //     sUrl= "/data/mc/po/essa-one/get-delivery-order";
        //     data = {
        //         deliveryOrderId	: this.props.deliveryOrderId,
        //     }
        // }
        this.loading(true);
        PickUpPoDrawerAction.postHttpAction(sUrl,data).then((res)=>{
            const resData = res.data||{}
            // 响应结果
            this.loading(false)
            let { success, valid, model} = resData;
            if (success && valid) {
                this.setState({
                    showStep: 2,
                    modelTwo: model,
                    selectIds:poIds||model.poIds,//编辑状态下 会返回 poIds数据
                    visible: true,
                });
                if(typeof callBack == 'function'){
                    callBack(model)
                }
            }
        })

    }
    /**
     * 提交预约
     * */
    async onSubmit(){
        let data = await this.onRefChildTwo.save()
        if(data){
            this.loading(true);
            const sUrl = "/mg/abd/whs/deliveryOrder/submit-delivery-order";
            const { buyerId,} = this.props;
            data["buyerId"] = buyerId;
            PickUpPoDrawerAction.postHttpAction(sUrl,data).then((res)=>{
                const resData = res.data||{}
                // 响应结果
                let { success, valid, model} = resData;
                if (success && valid) {
                    // 提交成功
                    message.info(__getServerLanguage("TiJiaoChengGong"))
                    this.showDrawer(false);
                    if(this.props.reLoad)this.props.reLoad()
                }
                this.timer =  setTimeout(()=>{
                    this.loading(false)
                },400)
            })

        }
    }
    // 初始化
    loading(flag){
        this.setState({
            loading:flag
        })
    }
    /**
     * 选择PO单预约提货
     * http://rap.essa.top:88/workspace/myWorkspace.action?projectId=211#7902
     * */
    initOne(){
        const { buyerId,} = this.props;
        const sUrl =  "/mg/abd/whs/deliveryOrder/query-booking-delivery-po";
        const data = {
            id: buyerId,
        }
        this.loading(true)
        PickUpPoDrawerAction.postHttpAction(sUrl,data).then((res)=>{
            const resData = res.data||{}
            // 响应结果
            this.loading(false);
            let { success, valid, model} = resData;
            const {
                inStoragePoList=[], payAmountPoList=[],arrivalPortDate
            } = model||{};
            if (success && valid) {
                this.setOneData(inStoragePoList,payAmountPoList,arrivalPortDate);
                this.setState({
                    visible: true,
                });
                const { selectPoIds } = this.props;
                if(selectPoIds&&selectPoIds.length>0){
                    const allList = [...inStoragePoList,...payAmountPoList];
                    let selectObj = {}
                    selectPoIds.forEach(selPo=>{
                        const has = allList.find(inPo=>inPo.poId==selPo);
                        if(has&&has.poId){
                            selectObj[selPo] = true;
                        }
                    })
                    this.setState({
                        selectObj: selectObj,
                    });

                }

            }
        })

    }
    /**
     * 设置第一步的数据
     * */
    setOneData(inStoragePoList=[],payAmountPoList=[],arrivalPortDate=""){
        this.setState({
            inStoragePoList:inStoragePoList||[],
            payAmountPoList:payAmountPoList||[],
            arrivalPortDate:arrivalPortDate,
        })
    }
    onChangeOne(selectObj={}){
        this.setState({
            selectObj:selectObj
        })
    }
    // 步骤组件
    onRefOne = (ref) =>this.onRefChildOne = ref;
    onRefTwo = (ref) =>this.onRefChildTwo = ref;
    componentWillMount(){
    }
    componentDidMount() {
        if(this.props.onRef)this.props.onRef(this);
    };
    componentWillUnmount() {
        if(this.timer)clearTimeout(this.timer);
    }
    render() {
        const {children,className, deliveryOrderId,buyerId } = this.props;
        const {showStep,selectIds,visible, loading, modelTwo,inStoragePoList, payAmountPoList,arrivalPortDate,selectObj } = this.state;
        return (<Spin spinning={loading}>
            {children?<span className={className}
                           onClick={()=>this.showDrawer(true)}>{children}</span>:<AuthBtn icon={"ri-calendar-todo-line"}
                                                                                         ips = {Lang({id:"YuYueTiHuo",default:"预约提货"})}
                                                                                         onClick={()=>this.showDrawer(true)} />}

             {/* this.titleOne(inStoragePoList,payAmountPoList) showStep==2?this.titleTwo(): */}
             {visible&&<Drawer title={<span />} //Lang({id:"YuYueTiHuo",default:"预约提货"})
                               extra={showStep==2?<Space>
                                   {/* 暂不预约 */}
                                   <Button onClick={()=>this.showDrawer(false)}>{Lang({id:"ZanBuYuYue",default:"暂不预约"})}</Button>
                                   {/* 选择订单, 编辑状态不显示 */}
                                   {!this.props.deliveryOrderId&&<Button className={"ml_12"} onClick={()=>this.showStep(1)}>
                                       {Lang({id:"XuanZeDingDan",default:"选择订单"})}
                                   </Button>}
                                   {/* 提交预约 */}
                                   <Button type={"primary"} className={"ml_12"}
                                           onClick={()=>this.onSubmit(2)}>{this.props.deliveryOrderId?Lang({id:"BaoCun",default:"保存"}):Lang({id:"TiJiaoYuYue",default:"提交预约"})}
                                   </Button>
                               </Space>:<Space>
                                   {/* 暂不预约 */}
                                   <Button onClick={()=>this.showDrawer(false)}>{Lang({id:"ZanBuYuYue",default:"暂不预约"})}</Button>
                                   {/* 下一步 */}
                                   {(inStoragePoList.length>0||payAmountPoList.length>0)?<Button type={"primary"}
                                                                                                 className={"ml_12"}
                                                                                                 onClick={()=>this.showStep(2)}>{__getServerLanguage("XiaYiBu")}</Button>:null}
                                    </Space>}
                    placement="right"
                    closable={false}
                    width={700}
                     maskClosable={false}
                    onClose={()=>this.showDrawer(false)}
                    open={visible}
                >
                <Spin spinning={loading}>
                {showStep==2?<StepSecond modelTwo={modelTwo}
                                         deliveryOrderId={deliveryOrderId}
                                         buyerId={buyerId}
                                         selectIds={selectIds}
                                         type={modelTwo.type}
                                         consigneeList={modelTwo?modelTwo.consigneeList:[]}
                                         reLoadTwo={(callBack)=>this.goStepTwo(selectIds,callBack)}
                                         onRef={this.onRefTwo} />:<StepOne onRef={this.onRefOne}
                                                                           buyerId={buyerId}
                                                                          selectObj={selectObj||{}}
                                                                          onChangeOne={(obj)=>this.onChangeOne(obj)}
                                                                          inStoragePoList={inStoragePoList}
                                                                          arrivalPortDate={arrivalPortDate}
                                                                          payAmountPoList={payAmountPoList}/>}
                </Spin>
            </Drawer>}
        </Spin>);
    }
}

